module.exports = __webpack_public_path__ + "static/media/ParserBackground.a71724a5.jpg";